<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form class="app-pay-form" @submit.prevent="send">
          <div class="col">
            <div class="inline-form">
              <label>Banka Hesapları</label>
              <select v-model="form.bank_id">
                  <option :value="null" disabled>Seçiniz</option>
                  <option v-for="(cepbank,key) in cepbanks" :key="key" :value="cepbank.id">{{ cepbank.name }}</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Gönderici Telefon Numarası</label>
              <input :type="isMobile ? 'tel' : 'number'" v-model="form.to_phone" placeholder="Gönderici Telefon Numarası" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Alıcı Telefon Numarası</label>
              <input :type="isMobile ? 'tel' : 'number'" v-model="form.from_phone" placeholder="Alıcı Telefon Numarası" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Alıcı TC Kimlik Numarası</label>
              <input :type="isMobile ? 'tel' : 'number'" v-model="form.tcno" placeholder="Alıcı TC Kimlik Numarası" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Şifre / Referans Numarası</label>
              <input :type="isMobile ? 'tel' : 'number'" v-model="form.refno" placeholder="Şifre / Referans Numarası" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Tutar</label>
              <input :type="isMobile ? 'tel' : 'number'" placeholder="Yatırım tutarınızı yazınız" v-model="form.amount">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Alıcı doğum Tarihi</label>
              <div class="row flow-row">
                  <div class="col">
                      <select name="birthday-day" v-model="form.birthday_day">
                        <option :value="null" disabled>Seçiniz</option>
                        <option v-for="item in 31" :key="item" :value="(_.includes([1,2,3,4,5,6,7,8,9], item) ? '0' + item : item)">{{ item }}</option>
                      </select>
                  </div>
                  <div class="col">
                      <select name="birthday-month" v-model="form.birthday_month">
                        <option :value="null" disabled>Seçiniz</option>
                        <option v-for="item in 12" :key="item" :value="(_.includes([1,2,3,4,5,6,7,8,9], item) ? '0' + item : item)">{{ item }}</option>
                      </select>
                  </div>
                  <div class="col">
                      <select name="birthday-year" v-model="form.birthday_year">
                        <option :value="null" disabled>Seçiniz</option>
                        <option v-for="item in _.range(1960, 2017)" :key="item" :value="item">{{ item }}</option>
                      </select>
                  </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Son geçerlilik tarihi (Kimlik)</label>
                <div class="row flow-row">
                    <div class="col">
                      <select name="birthday-day" v-model="form.valid_day">
                        <option :value="null" disabled>Seçiniz</option>
                        <option v-for="item in 31" :key="item" :value="(_.includes([1,2,3,4,5,6,7,8,9], item) ? '0' + item : item)">{{ item }}</option>
                      </select>
                    </div>
                    <div class="col">
                      <select name="birthday-month" v-model="form.valid_month">
                        <option :value="null" disabled>Seçiniz</option>
                        <option v-for="item in 12" :key="item" :value="(_.includes([1,2,3,4,5,6,7,8,9], item) ? '0' + item : item)">{{ item }}</option>
                      </select>
                    </div>
                    <div class="col">
                      <select name="birthday-year" v-model="form.valid_year">
                        <option :value="null" disabled>Seçiniz</option>
                        <option v-for="item in _.range(1960, 2099)" :key="item" :value="item">{{ item }}</option>
                      </select>
                    </div>
                </div>
            </div>
          </div>
          <div class="col">
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Yatır'" />
          </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props:['providerInfo'],
    data(){
      return{
        form:{
          bank_id: null,
          to_phone: null,
          from_phone: null,
          amount: null,
          tcno: null,
          refno: null,
          birthday_day:null,
          birthday_month: null,
          birthday_year: null,
          valid_day:null,
          valid_month: null,
          valid_year: null,
          bonus_id: 0,
        },
        loading: false,
        btnLoading: false,
        min_pay: null,
        max_pay: null,
        cepbanks: null,
        cepbank:null,
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData() {
        axios.get('/user/wallet/deposit/cepbank/list')
        .then((response) => {
          this.cepbanks 	  = response.data.list;
        })
        .catch((err) => {
        })
      },
      send(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/deposit/cepbank/create', this.form)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          };
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
      }
    },
    watch: {
      'form.bank_id': function(bank_id) {
        this.cepbank = _.find(this.cepbanks, {"id": bank_id});
      }
    },
    components:{
      Header,
      Form
    }
  }

</script>